import { useCreateInventoryPartMutation } from "../../api/api-hooks";
import { AddPartsForm } from "./inventoryTypes";

const useInventoryPartCreator = () => {
  const [createPart] = useCreateInventoryPartMutation();
  return (item: AddPartsForm) => {
    return createPart({
      createInventoryPartDto: {
        partName: item.partName,
        amount: Number(item.amount),
      },
    });
  };
};

export default useInventoryPartCreator;
